import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import * as packageJson from 'package.json';
import { ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Branch } from 'src/app/models/branch';
import { ExchangeRate } from 'src/app/models/exchange-rate';
import { FiscalEmissionPoint } from 'src/app/models/fiscal-emission-point';
import { Menu } from 'src/app/models/menu';
import { INavDataRoles } from 'src/app/models/nav-data-roles';
import { Register } from 'src/app/models/register';
import { SalesOrg } from 'src/app/models/sales-org';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { FiscalEmissionPointService } from 'src/app/services/fiscal-emission-point.service';
import { navItemsWithRoles } from '../../../nav';
import { ParamsService } from './../../services/params.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.sass']
})
export class LayoutComponent implements OnInit, AfterViewInit {

  public sidebarMinimized = true;
  public navItems: INavDataRoles[] = [];
  public profile: User = new User();

  public salesOrgs: Array<SalesOrg> = [];
  public salesOrg: string = "";
  public salesOrgObject: SalesOrg = new SalesOrg();
  public branches: any = {};
  public filteredBranches: Array<Branch> = [];
  public branch?: Branch = new Branch();
  public branchObject: Branch = new Branch();

  public exchangeRate: ExchangeRate = new ExchangeRate();

  public register: Register = new Register();
  public fiscalEmissionPoint: FiscalEmissionPoint = new FiscalEmissionPoint();

  popOverOpen: boolean = false;
  popOverOpenNav: boolean = false;
  showMenu: boolean = true;
  canShowGoToLegacyPOSLink = false;
  constructor(private authService: AuthService,
    private configurationService: ConfigurationService,
    private confirmService: PosConfirmationService,
    private exchangeRateService: ExchangeRateService,
    private router: Router,
    private readonly paramsService: ParamsService,
    private readonly fiscalEmissionPointService: FiscalEmissionPointService,) {
    let userRoles = Array.from(this.authService.readRolesInStorage());
    navItemsWithRoles.forEach((f: INavDataRoles) => {
      if (f.roles && f.roles.some((s) => userRoles.includes(s)) || !f.roles) {
        this.navItems.push(f);
      }
    });




  }

  ngOnInit() {
    this.loadConfiguration();
    this.showMenu = this.configurationService.getMenu();
  }

  async loadConfiguration(): Promise<void> {
    this.setMenus();

    this.exchangeRate = await this.exchangeRateService.readLatestExchangeRate();
    this.salesOrgs = this.configurationService.readSalesOrg();
    this.branches = this.configurationService.readBranch();
    this.salesOrgObject = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg;
    this.salesOrg = this.salesOrgObject.code;
    this.branchObject = this.configurationService.readSelectedBranchAndSalesOrg().branch;
    this.branch = this.branchObject;
    this.filteredBranches = this.branches[this.salesOrg] || [];
    this.register = this.configurationService.readRegister();
    this.fiscalEmissionPoint = (await this.fiscalEmissionPointService.readFiscalEmissionPoints(this.register.code, this.salesOrg).toPromise()).response.content[0] ?? new FiscalEmissionPoint();

    await this.hideOrderChecklistMenu();
    await this.hideGoToLegacyPOSLink();
    console.log(this.navItems);
  }
  async hideOrderChecklistMenu() {
    const hide = (await this.paramsService.readParam("hide-order-checklist-menu").toPromise()).response;
    if (hide.value.toLowerCase() != "no") {
      const branches = (await this.paramsService.readParam("send-to-email-disabled-branches").toPromise()).response;
      if (branches.value.split(',').some(s => s == this.configurationService.readSelectedBranchAndSalesOrg().branch.code)) {
        this.navItems = this.navItems.filter(n => n.name != "Ordenes de Entrega");
      }
    }
  }

  setMenus() {
    this.navItems = [];
    const menus = Array.from(this.authService.readMenusInStorage())?.filter(f => f.salesOrg.includes(this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code));
    this.navItems.push(navItemsWithRoles[0]);

    menus.forEach(f => {
      if (f.children) {
        f.children.forEach(f2 => {
          if (f2.children) {
            f2.children = f2.children.length > 0 ? f2.children : undefined;
          }
        })

        f.children = f.children.length > 0 ? f.children : undefined;
      }
    })
    this.navItems = this.navItems.concat(menus.map(m => {
      const localmenu = (menus.find(s => s.name === m.name) ?? new Menu());
      let menuToInsert: INavDataRoles = {
        name: localmenu.name,
        url: this.getActiveUrl(localmenu),
        icon: localmenu.icon,
        children: localmenu.children?.map(m2 => {
          let result: INavDataRoles = {};
          result.name = m2.name;
          result.icon = m2.icon;
          result.url = m2.redirectTo;
          result.children = m2.children?.map(m3 => {
            let result: INavDataRoles = {};
            result.name = m3.name;
            result.icon = m3.icon;
            result.url = m3.redirectTo;
            return result;
          })
          return result;
        })
      };
      let childrenToInsert = m.children && m.children.length > 0 ? m.children.map(x => {
        const result: INavDataRoles = {

        };

        result.name = x.name;
        result.icon = x.icon;
        result.url = x.redirectTo;
        result.children = x.children && x.children.length > 0 ? x.children.map(y => {
          const result2: INavDataRoles = {};
          result2.name = y.name;
          result2.icon = y.icon;
          result2.url = y.redirectTo;
          return result2;
        }) : undefined;

        if (result.children) {
          result.children = result.children || [];
          result.children.push(...childrenToInsert!);
          result.children = result.children.reduce((unique, item) =>
            unique.some(s => s.name === item.name) ? unique : [...unique, item], new Array<INavDataRoles>());
        }
        result.children = result.children && result.children.length > 0 ? result.children : undefined;
        return result;
      }) : undefined;

      if (childrenToInsert) {
        menuToInsert.children = menuToInsert.children || [];
        menuToInsert.children.push(...childrenToInsert);
        menuToInsert.children = menuToInsert.children.reduce((unique, item) =>
          unique.some(s => s.name === item.name) ? unique : [...unique, item], new Array<INavDataRoles>());
      }
      menuToInsert.children = menuToInsert.children && menuToInsert.children.length > 0 ? menuToInsert.children : undefined;
      return menuToInsert;
    }));
    this.navItems = this.navItems.reduce((unique, item) =>
      unique.some(s => s.name === item.name) ? unique : [...unique, item], new Array<INavDataRoles>())
    this.navItems.push(navItemsWithRoles[navItemsWithRoles.length - 1]);
  }

  private getActiveUrl(localmenu: Menu): string | any[] | undefined {

    const isAnyActive = localmenu.children && localmenu.children.length > 0 ? localmenu.children?.some(s => this.router.isActive(s.redirectTo, false)) : false;

    return !isAnyActive && !localmenu.redirectTo ? " " : localmenu.redirectTo;
  }

  filterBranches() {
    if (!this.salesOrg) {
      this.filteredBranches = [];
    }
    this.filteredBranches = this.branches[this.salesOrg];
    this.branch = undefined;
  }
  async ngAfterViewInit() {
    this.profile = (await this.authService.readProfileInStorage());
  }

  toggleMinimize(e: boolean) {
    this.sidebarMinimized = e;
  }

  async changeBranch(pop: PopoverDirective): Promise<void> {
    let selectedBranch = this.filteredBranches.find(f => f.code == this.branch!.code);
    let selectedSalesOrg = this.salesOrgs.find(f => f.code == this.salesOrg);
    pop.hide();

    await this.confirmService.show("Cambio de tienda",
      `Está seguro que desea cambiar a la tienda ${selectedBranch?.code} - ${selectedBranch?.name}`,
      ModalDialogType.INFO,
      () => {
        this.configurationService.createSelectedBranchAndSalesOrg({ salesOrg: selectedSalesOrg, branch: selectedBranch || new Branch() });

        const route = this.configurationService.readSelectedBranchAndSalesOrg().salesOrg.code == "1300" ? "cashLoans" : "";
        this.router.navigateByUrl(route).then(v => {
          window.location.reload();
        });
      });
  }

  changePassword() {

  }

  customSearchBranches(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item['name'].toLocaleLowerCase().indexOf(term) > -1 || item['code'].toString().indexOf(term) > -1;
  }

  get version() {
    return packageJson.version;
  }

  async hideGoToLegacyPOSLink() {
    const branchesList = (await this.paramsService.readParam("branches-pos-legacy-access").toPromise()).response;
    this.canShowGoToLegacyPOSLink = branchesList.value.includes(this.configurationService.readSelectedBranchAndSalesOrg().branch.code);
  }

  handleGoToPosLegacyClick() {
    window.open(environment.urlPosLegacy, '_blank', 'noopener');
  }
}
